import { useCallback } from 'react';
import { gql, useMutation } from '@material-bank/graphql-client';
type UpdateTapLocationData = {
  updateTapLocation: {
    success: boolean;
  };
};
type UpdateTapLocationVars = {
  input: {
    tapId: string;
    latitude: number;
    longitude: number;
  };
};
const updateTapLocationMutation = gql`
  mutation UpdateTapLocation($input: UpdateTapLocationInput!) {
    updateTapLocation(input: $input) {
      success
    }
  }
`;
export function useUpdateTapLocation() {
  const [mutate, {
    loading,
    error
  }] = useMutation<UpdateTapLocationData, UpdateTapLocationVars>(updateTapLocationMutation);
  const updateLocation = useCallback(async (tapId: string, latitude: number, longitude: number) => {
    try {
      const result = await mutate({
        variables: {
          input: {
            tapId,
            latitude,
            longitude
          }
        }
      });
      return result.data?.updateTapLocation.success ?? false;
    } catch {
      return false;
    }
  }, [mutate]);
  return {
    updateLocation,
    loading,
    error
  };
}